export default {
  logs: {
    export: {
      btn: '导出',
      text: '操作日志'
    },
    overtimeError: '所查询的日志时间已经超过一年，请重新选择时间',
    operateSystem: {
      value3: 'Scanat App',
      value4: 'Scanat Web',
      value1: 'ID管理系统'
    },
    operatePage: {
      login: '登录注册',
      personal_setting: '个人设置',
      local_model: '本地模型',
      in_box: '收件箱',
      cloud_model: '云端模型',
      sample_model: '样本列表',
      main_list: '主列表',
      member_manage: '团队管理',
      company_info: '公司信息',
      order_manage: '订单管理',
      SharedSpace: '共享空间',
      TeamsSpace: '团队空间',
      team_space: '团队空间',
      personal_space: '个人空间',
      model_link: '模型链接',
      invite_link: '邀请链接'
    },
    operateType: {
      login: '登录',
      register: '注册',
      cancellation: '注销',
      deleteModel: '删除模型',
      addModel: '新建模型',
      viewModel: '查看模型',
      viewSampleModel: '查看模型',
      editModel: '修改模型',
      editModelInfo: '修改模型',
      editModelAvatar: '修改模型',
      editModelName: '修改模型',
      shareModel: '分享模型',
      copyModelShareLink: '分享模型',
      moveModel: '移动模型',
      uploadModel: '上传模型',
      exportModel: '导出模型',
      copyModel: '复制模型',
      applyCad: '申请CAD',
      addFolder: '新建文件夹',
      editFolder: '修改文件夹',
      deleteFolder: '删除文件夹',
      moveFolder: '移动文件夹',
      downloadModel: '下载模型',
      buyAccountPlan: '购买套餐',
      inviteMember: '新增成员',
      addEnableMember: '新增成员',
      addDisableMember: '新增成员',
      enableMember: '修改成员',
      disableMember: '修改成员',
      setMemberAdmin: '修改成员',
      unsetMemberAdmin: '修改成员',
      editMemberName: '修改成员',
      editCustomerInfo: '修改信息',
      downloadInvoices: '下载发票',
      addId: '席位扩容',
      switchCard: '更换扣费信用卡',
      batchAdd: '批量新增',
      batchDelete: '批量移除',
      activeMember: '激活成员',
      deleteMember: '移除成员',
      payOrder: '支付订单',
      cancelOrder: '取消订单',
      PermissionChange: '修改权限',
      URLreset: '重置链接',
      FolderSharing: '分享文件夹',
      expandOrder: '席位扩容',
      changeCard: '更换扣费信用卡',
      batchAddMembers: '批量新增',
      batchDeleteMembers: '批量移除',
      exportMember: '导出',
      buyOrder: '购买套餐',
      addMember: '新增成员',
      editCustomer: '修改信息',
      applyToCancle: '申请取消订阅',
      planCancelApplication: '申请取消订阅',
      editLink: '修改链接',
      moveModelHome: '移动模型',
      moveFolderHome: '移动文件夹',
      copyLink: '分享模型',
      changeLink: '修改链接',
      changeLinkPassword: '修改链接',
      resetPassword: '重置密码',
      addMemberNew: '新增成员',
      editMemberStatus: '修改成员',
      editMemberNew: '修改成员',
      enable: '启用成员',
      disable: '禁用成员',
      changeSeat: '修改席位',
      changeRole: '修改角色',
      uploadFile: '导入模型文件',
      manageCollaborator: '设置协作者',
      moveFolderToFolder: '移动文件夹',
      moveFolderToRoot: '移动文件夹',
      moveModelToFolder: '移动模型',
      moveModelToRoot: '移动模型',
      addCollaborator: '设置协作者',
      deleteCollaborator: '设置协作者',
      updateCollaborator: '设置协作者',
      inviteCollaborator: '邀请协作者',
      resentInvite: '邀请协作者',
      resentInviteWithDate: '邀请协作者',
      acceptInvite: '接受邀请',
      viewFolder: '查看文件夹',
      uploadToFolder: '上传模型',
      uploadToRoot: '上传模型',
      importFileToRoot: '导入模型文件',
      importFileToFolder: '导入模型文件'
    },
    detail: {
      register: '注册了新账号',
      login: '登录了系统',
      cancellation: '注销了账号',
      deleteModel: '删除了模型【{detail0}】',
      addModel: '扫描了模型【{detail0}】，扫描方式为【{detail1}】',
      viewModel: '查看了模型【{detail0}】',
      editModelInfo: '修改了模型【{detail0}】信息为【模型名称：{detail1}；邮编：{detail2}；地址：{detail3}；建筑名称：{detail4}】',
      editModelAvatar: '修改了模型【{detail0}】的封面图',
      editModel: '对模型【{detail0}】进行了【{detail1}】操作',
      moveModel: '移动模型【{detail0}】至文件夹【{detail1}】',
      uploadModel: '上传模型【{detail0}】至云端',
      exportModel: '导出模型【{detail0}】的数据',
      copyModel: '复制了模型【{detail0}】为【{detail1}】',
      applyCad: '提交了模型【{detail0}】的 CAD申请',
      addFolder: '新建了文件夹【{detail0}】',
      editFolder: '修改了文件夹【{detail0}】名称为【{detail1}】',
      deleteFolder: '删除了文件夹【{detail0}】',
      moveFolder: '移动文件夹【{detail0}】至文件夹【{detail1}】',
      downloadModel: '下载了模型【{detail0}】',
      viewSampleModel: '查看了模型【样本模型】',
      editModelName: '修改了模型【{detail0}】名称为【{detail1}】',
      buyAccountPlan: '购买了【{detail0}】，含{detail1}个席位，税后金额{detail2}日元，付款方式为【{detail3}】',
      addEnableMember: '新增成员【{detail0}】，状态为【可用】',
      addDisableMember: '新增成员【{detail0}】，状态为【不可用】',
      inviteMember: '新增成员【{detail0}】，等待对方接受邀请',
      enableMember: '设置成员【{detail0}】状态为【可用】',
      disableMember: '设置成员【{detail0}】状态为【不可用】',
      setMemberAdmin: '设置成员【{detail0}】为管理员',
      unsetMemberAdmin: '取消设置成员【{detail0}】为管理员',
      editMemberName: '修改成员【{detail0}】名称为【{detail1}】',
      editCustomerInfo: '修改了公司信息为【邮政编码：{detail0}；都道府县：{detail1}；直辖市：{detail2}；地区名称：{detail3}；负责人姓：{detail4}；负责人名：{detail5}；电话号码：{detail6}；所属行业：{detail7}；员工人数：{detail8}；主营业务：{detail9}】',
      downloadInvoices: '下载了订单【{detail0}】的发票至本地',
      moveModelHome: '移动模型【{detail0}】至【主目录】',
      moveFolderHome: '移动文件夹【{detail0}】至【主目录】',
      expandOrder: '提交了【席位扩容】订单，订单信息：【订单号：{detail0}；套餐：{detail1}；订单类型：扩容；订购方式：{detail2}；新增席位数：{detail3}；席位加入时间：{detail4}；总金额：{detail5}；税费：{detail6}；应付金额：{detail7}】',
      buyOrder: '提交了【购买套餐】订单，订单信息：【订单号：{detail0}；套餐：{detail1}；订单类型：购买；订购方式：{detail2}；席位数：{detail3};  总金额：{detail4}；税费：{detail5}；应付金额：{detail6}】',
      changeCard: '更换了扣费信用卡为{detail0}',
      addMember: '新增成员【{detail0}】，状态为【{detail1}】',
      batchAddMembers: '批量新增了{detail0}位成员',
      batchDeleteMembers: '批量移除了{detail0}位成员',
      exportMember: '导出了成员列表',
      activeMember: '激活了成员【{detail0}】',
      deleteMember: '移除了成员【{detail0}】',
      editCustomer: '修改了公司信息为【公司名称：{detail0}，主担当者：{detail1}，{detail2}，{detail3}；邮编：{detail4}；地址：{detail5}；行业分类：{detail6}；员工规模：{detail7}；注册资本：{detail8}；主营业务：{detail9}】',
      payOrder: '支付了订单【{detail0}】，支付方式为【{detail1}】',
      cancelOrder: '取消了订单【{detail0}】',
      SendModelViewable: '分享模型【{detail0}】给用户【{detail1}】，访问权限为【可查看】',
      CopiedModelPrivateLink: '复制了模型【{detail0}】的【私密链接】',
      AddedModelMember: '针对模型【{detail0}】，添加成员【{detail1}】为【可查看】权限',
      UpdatedModelMember: '针对模型【{detail0}】，修改成员【{detail1}】为【可编辑】权限',
      RemovedModelViewable: '针对模型【{detail0}】，删除成员【{detail1}】的【可查看】权限',
      ResetModelPrivateLink: '重置了模型【{detail0}】的【私密链接】',
      SharedFolder: '分享文件夹【{detail0}】给用户【{detail1}】',
      CopiedFolderPublicLink: '复制了文件夹【{detail0}】的【公开链接】',
      ResetModelPublicLink: '重置了模型【{detail0}】的【公开链接】',
      SendModelEditable: '分享模型【{detail0}】给用户【{detail1}】，权限为【可编辑】',
      RenamedFolder: '修改了文件夹【{detail0}】为【文件夹名称：{detail1}；简介：{detail2}】',
      SharedFolderViewable: '分享文件夹【{detail0}】给用户【{detail1}】，权限为【可查看】',
      CopiedFolderPrivateLink: '复制了文件夹【{detail0}】的【私密链接】',
      AddedFolderMember: '针对文件夹【{detail0}】，添加成员【{detail1}】为【可查看】权限',
      UpdatedFolderMember: '针对文件夹【{detail0}】，修改成员【{detail1}】为【可编辑】权限',
      RemovedFolderViewable: '针对文件夹【{detail0}】，删除成员【{detail1}】的【可查看】权限',
      ResetFolderPublicLink: '重置了文件夹【{detail0}】的【公开链接】',
      addModel1: '简易扫描',
      addModel2: '详细扫描',
      editModel1: '切割',
      editModel2: '对齐',
      editModel3: '变形',
      buyAccountPlan2: '请求书',
      buyAccountPlan1: '信用卡',
      editCustomerSex0: '男',
      editCustomerSex1: '女',
      editCustomerInfo1: '建筑业',
      editCustomerInfo2: '制造业',
      editCustomerInfo3: '房地产业・物品租赁业',
      editCustomerInfo4: '信息通信业',
      editCustomerInfo5: '电力・燃气・热力・自来水业',
      editCustomerInfo6: '运输业・邮政业',
      editCustomerInfo7: '信息处理服务业',
      editCustomerInfo8: '学术研究・专业・技术服务业',
      editCustomerInfo9: '批发业・零售业',
      editCustomerInfo10: '调研业',
      editCustomerInfo0: '-',
      editCustomerInfoStaff1: '1~50',
      editCustomerInfoStaff2: '51~100',
      editCustomerInfoStaff3: '100人以上',
      editCustomerInfoStaff0: '-',
      editCustomer1: '建筑业',
      editCustomer2: '制造业',
      editCustomer3: '房地产业・物品租赁业',
      editCustomer4: '信息通信业',
      editCustomer5: '电力・燃气・热力・自来水业',
      editCustomer6: '运输业・邮政业',
      editCustomer7: '信息处理服务业',
      editCustomer8: '学术研究・专业・技术服务业',
      editCustomer9: '批发业・零售业',
      editCustomer10: '调研业',
      editCustomer0: '-',
      editCustomerStaff1: '1~50',
      editCustomerStaff2: '51~100',
      editCustomerStaff3: '100人以上',
      editCustomerStaff0: '-',
      payOrder1: '信用卡',
      payOrder2: '请求书',
      addMember0: '未激活',
      addMember1: '使用中',
      period1: '年付',
      period2: '月付',
      applyToCancle: '提交了取消订阅申请',
      planCancelApplication: '提交了取消订阅申请',
      shareModel: '分享模型【{detail0}】给用户【{detail1}】',
      copyModelShareLink: '复制了模型【{detail0}】的分享链接',
      changeLinkPassword: '修改了模型【{detail0}】加密链接的密码',
      ResetModelLink: '重置了模型【{detail0}】的【{detail1}】',
      ResetFolderLink: '重置了文件夹【{detail0}】的【{detail1}】',
      resetPassword: '重置了密码',
      copyLink1: '私密链接',
      copyLink2: '加密链接',
      copyLink3: '公开链接',
      changeLink1: '私密链接',
      changeLink2: '加密链接',
      changeLink3: '公开链接',
      copyLink: '复制了模型【{detail0}】的【{detail1}】',
      changeLink: '修改了模型【{detail0}】的分享链接权限为【{detail1}】',
      editMemberStatus: '修改成员【{detail0}】状态为【{detail1}】',
      addMemberNew: '新增成员【{detail0}】，角色为【{detail1}】，席位状态【{detail2}】，状态为【使用中】',
      editMemberNew: '修改成员【{detail0}】的名称为【{detail1}】，角色为【{detail2}】，席位状态为【{detail3}】',
      enable: '启用成员【{detail0}】',
      disable: '禁用成员【{detail0}】',
      changeSeat: '修改成员【{detail0}】的席位状态为【{detail1}】',
      changeRole: '修改成员【{detail0}】的角色为【{detail1}】',
      role1: '超级管理员',
      role3: '管理员',
      role0: 'Scanat用户',
      role4: '浏览用户',
      changeSeat1: '开启',
      changeSeat0: '关闭',
      uploadFile: '导入了模型【{detail0}】，导入文件类型为{detail1}',
      uploadToFolder: '上传模型【{detail0}】至{detail1}的文件夹【{detail2}】',
      uploadToRoot: '上传模型【{detail0}】至{detail1}的【主目录】',
      moveFolderToFolder: '移动文件夹【{detail0}】至{detail1}的文件夹【{detail2}】',
      moveFolderToRoot: '移动文件夹【{detail0}】至{detail1}的【主目录】',
      moveModelToFolder: '移动模型【{detail0}】至{detail1}的文件夹【{detail2}】',
      moveModelToRoot: '移动模型【{detail0}】至{detail1}的【主目录】',
      addCollaborator: '在{detail0}【{detail1}】中添加了协作者【{detail2}】，权限为【{detail3}】',
      deleteCollaborator: '在{detail0}【{detail1}】中删除了协作者【{detail2}】',
      updateCollaborator: '修改了{detail0}【{detail1}】中协作者【{detail2}】的权限为【{detail3}】',
      space0: '个人空间',
      space1: '团队空间',
      collaboratorPermission0: '仅查看',
      collaboratorPermission1: '可编辑',
      collaboratorPermission2: '可管理',
      fileType0: '模型',
      fileType1: '文件夹',
      importFile: '导入了模型【{detail0}】，上传导入文件类型为{detail1}',
      inviteCollaborator: '邀请了【{detail0}】，权限为【{detail1}】，有效期为【{detail2}天】',
      resentInvite: '向【{detail0}】重新发送了协作者邀请',
      resentInviteWithDate: '向【{detail0}】重新发送了协作者邀请，并设置有效期为【{detail1}天】',
      acceptInvite: '接受了协作者邀请',
      viewFolder: '查看了文件夹【{detail0}】',
      importFileToRoot: '导入模型【{detail0}】至{detail1}的【主目录】，导入文件类型为{detail2}',
      importFileToFolder: '导入模型【{detail0}】至{detail1}的文件夹【{detail2}】，导入文件类型为{detail3}'
    }
  },
  common: {
    close: '关闭',
    got: '我知道了',
    title: {
      email: '邮箱'
    },
    cancel: '取消',
    share: '分享',
    settings: '设置',
    save: '保存',
    yes: '是',
    no: '无',
    done: '已完成/完成',
    name: '名称',
    loading: '加载中',
    back: '返回',
    deleteConfirm: '要删除吗？',
    delete: '删除',
    rename: '更改名称',
    empty: '没有可用数据',
    inputhint: '请输入',
    pre: '上一个',
    next: '下一个',
    beginning: '第一页',
    last: '最后一页',
    forwardPage: '跳转',
    summary: '共{n}条',
    ok: '确定',
    select: '选择',
    confirm: '确认',
    selectAll: '全选',
    all: '全部',
    minimize: '最小化',
    submit: '提交',
    deregister: '注销',
    action: '操作',
    active: '激活',
    edit: '编辑',
    more: '更多',
    batch: '批量操作',
    MultiDelete: '批量移除',
    export: '导出',
    setDefault: '设为默认',
    create: '新增',
    fillin: '去填写',
    reset: '重置',
    other: '其他',
    input: '请输入',
    selectHint: '请选择',
    uploadFile: '上传文件',
    uploadForm: '上传表格',
    steps: '操作步骤',
    import: '确认导入',
    download: '下载',
    note: '备注',
    normalTip: '温馨提示',
    clear: '清空',
    member: '成员',
    memberPermission: '成员与权限',
    move: '移动',
    remove: '移除',
    scanatId: 'Scanat ID',
    startTime: '开始时间',
    endTime: '结束时间',
    page: {
      total: '总计 {detail0} 条',
      first: '首页',
      previous: '上一页',
      next: '下一页',
      last: '末页',
      go: '前往第{detail0}页',
      perPage: '条/页'
    }
  },
  mesh: {
    export: '导出模型数据',
    download: '数据下载',
    all: '所有数据',
    tip: '打包并导出模型所有数据',
    default: '网格',
    pointCloud: '点云',
    processing: '正在处理',
    gltf: '用于安卓',
    obj: '应用广泛',
    stl: '用于3D打印机'
  },
  week: {
    mon: '一',
    tue: '二',
    wed: '三',
    thu: '四',
    fri: '五',
    sat: '六',
    sun: '日'
  },
  month: {
    jan: '1月',
    feb: '2月',
    mar: '3月',
    apr: '4月',
    may: '5月',
    jun: '6月',
    jul: '7月',
    aug: '8月',
    sep: '9月',
    oct: '10月',
    nov: '11月',
    dec: '12月'
  },
  login: {
    passwordWrong: '请输入正确的密码',
    accountUndefined: '用户名不存在',
    verifiWrong: '验证码不正确',
    verifiExpired: '验证码已过期',
    loginVerifiSent: '登录验证码已发送到您的电子邮箱',
    verifiSend: '重新发送验证码',
    login: '登录',
    register: '注册',
    back: '回到登录页面',
    guideRegister: '点击这里注册新账户',
    newAccount: '新用户注册',
    email: '电子邮箱地址',
    password: '密码',
    forgetPassword: '忘记密码？',
    emailError: '电子邮箱格式不正确',
    passwordTip: '密码必须在10到50个字符之间，且至少包含一个半角英文字母和一个数字字符。',
    emailNone: '该电子邮箱地址未注册',
    accountError: '用户名或密码不正确。',
    resetPasswordSent: '已发送电子邮件重置您的密码。',
    verifiSent: '验证码已发送到您的电子邮箱',
    passwordConfirm: '确认密码',
    send: '发送',
    sent: '已发送验证码',
    verify: '验证码',
    inputVerify: '输入您电子邮件中收到的 6 位验证码',
    resetPassword: '重置密码',
    noEmpty: '不允许出现空元素\n（注：必填项没填点提交，出现了该提示）',
    verifyFormat: '验证码必须为 6 位数',
    verifyNumber: '验证码为6位数纯数字',
    checkPassword: '请检查您的密码',
    resetPasswordSuccess: '密码已重置成功',
    existUser: '该用户已存在',
    loginSuccess: '已成功登录',
    registerSuccess: '已成功注册',
    logout: '登出',
    terms: '我同意 <link>Scanat 使用条款</link>',
    termsError: '请阅读并勾选使用条款后，再提交注册',
    alert: {
      title: '提示',
      info: '我们已经向您发送了一封电子邮件，其中包含用于完成重置密码的链接'
    },
    invalid: {
      info: '该重置密码链接已失效',
      tip: '请重新获取重置密码链接'
    },
    noExist: {
      info: '链接不存在',
      tip: '请检查链接是否正确'
    },
    go: '前往',
    forgetPasswordToast: '请求过于频繁，请1分钟后再试',
    introduction: '数字化空间，创造未来',
    verifyText: '验证码'
  },
  error: {
    connectionOut: '连接超时，请检查网络连接或稍后再试。',
    server: '服务器过载正在维护，请稍后再试。',
    connectionCheck: '请检查网络连接',
    contactManage: '没有访问权限，请联系您的管理员',
    noPlan: '暂未购买套餐，无法使用该服务。',
    overDate: '您企业的套餐{plan}已于{date}过期，无法使用该服务。',
    unactive: '您企业的套餐{plan}将于{date}生效，请在套餐生效后访问。',
    needLevelUp: '您的企业暂未购买该服务',
    noService: '您的企业暂未购买该服务，无法访问',
    emptyName: '姓或名不能为空',
    unsaveEdit: '请先保存编辑的内容',
    overSeat: '席位数已达上限，无法添加成员。请先移除部分成员，或进行席位扩容',
    noSelectMember: '请先在下方勾选需要移除的成员',
    bestPlan: '当前套餐为最高版本，无法升级',
    noPermission: '暂无权限',
    comInfoAction: '完善企业信息',
    comInfoModal: '您好，您的企业信息尚未完善，请填写企业信息',
    comInfoBuy: '请先完善企业信息，再进行购买。',
    comInfoHome: '温馨提示：企业信息未完善，将影响功能使用',
    usedAccount: '该账号已属于其他会社，无法添加，请重新填写',
    wrongEmail: '请输入正确的邮编',
    unsavePage: '请先保存当前页面的内容',
    repetitiveMail: '表格中存在重复的邮箱，请检查后重新上传',
    otherMember: '邮箱{email}为已有账号，请检查后重新上传',
    wrongFormat: '邮箱{email}格式有误，请修改后重新上传',
    creditExpired: '您的信用卡已过期，请检查有效期或更换卡片',
    agreement: '请勾选同意《购买协议》',
    payFailed: '支付失败，请检查信用卡是否可正常使用',
    noAccess: '当前页面无法访问',
    emailEmpty: '第{n}行邮箱未填写，请填写后重新上传',
    nameExceed: '第{n}行的姓或名不能超过10个字，请修改后重新上传',
    overSeatActivation: '席位数已达上限，无法激活成员。请先移除部分成员，或进行席位扩容',
    importExceed: '导入成员数量不能大于100，请在表格中删除部分成员后重新上传',
    existCompany: '该账号已在当前会社，无需重复添加',
    invalidAccount: '账号无效，请联系您的管理员',
    creditDisable: '信用卡不可用，请检查后重新填写',
    code: {
      '403': '您的访问被拒绝',
      '404': '页面不存在',
      '500': '服务器过载，正在维护中。请稍后重试。',
      '502': '服务器繁忙，请稍后再试',
      '504': '服务器繁忙，请稍后再试'
    },
    accountDisable: '账号已被禁用，无法访问',
    noSeat: '账号未开通席位，无法使用app',
    noRight: '您的账号无权限访问该服务。',
    oneDevice: '出于安全考虑，Scanat Web不允许在多台设备上同时登录。您的帐户已被自动登出。请重新登录。',
    overDue: '会话已过期。请重新登录。',
    checkNetWork: '请检查您的网络连接。',
    timeOut: '连接超时。请检查您的网络连接或稍后重试。',
    noCompanyInfo: '您的企业信息尚未填写。在“企业信息”菜单栏中完成企业信息的填写后，才可购买套餐。',
    comInfoDomain: '请先完善企业信息，再添加域名',
    accountNoAccess: '账号已被禁用，无法登录',
    existName: '名称已存在，请重新填写',
    nameTooLong: '模型名称不可超过20个字符，请修改后重新上传',
    noModel: '暂无模型数据'
  },
  complete: {
    save: '保存成功',
    export: '导出成功',
    setManagement: '设置管理员成功',
    cancelSetManag: '取消管理员成功',
    card: '信用卡已添加',
    cardUpdate: '信用卡已更新',
    cardDeleted: '信用卡已删除',
    importMember: '导入成功',
    invoiceDown: '下载发票成功',
    diagramDown: '下载图纸成功',
    invoiceSent: '请求书发送成功',
    bought: '恭喜你，购买成功',
    add: '添加成功',
    change: '修改成功',
    delete: '已删除',
    replace: '更换成功'
  },
  landing: {
    select: '请选择要访问的系统',
    idManage: 'ID管理系统',
    scanatWeb: 'Scanat Web',
    pwChange: '修改密码',
    logout: '退出登录',
    tipId: '· 账户管理\n  (如更新状态、切换管理权限等）\n· 购买计划\n· 下载发票和收据',
    tipScanat: '· 全公司和个人云数据管理（如创建个人文件夹）\n· 通过 PC 浏览器进行模型操作和测量数据编辑\n· 与内部用户同时查看模型和编辑测量数据',
    alertNoPlan: 'Scanat Web 是企业计划（B 计划及以上）的可选功能。这是一项方便的功能，允许在浏览器中查看和操作使用应用程序扫描的模型，并创建模型链接与非 Scanat 用户共享。\n\n如需了解更多信息，请使用<link>联系表格</link>或联系您的销售代表。',
    invalidAccount: '您的账号已失效，无法访问Scanat Web，请联系管理员',
    unnamed: '未命名'
  },
  file: {
    allFile: '全部文件',
    sample: '样例模型',
    modelAmount: '模型数量',
    newFolder: '新建文件夹',
    fileName: '名称',
    owner: '所有者',
    time: '上传时间',
    createTime: '创建时间',
    scanner: '拍摄者',
    scanTime: '拍摄时间',
    editor: '最后编辑者',
    updateTime: '更新时间',
    folder: '文件夹',
    fileAmount: '{n} 个文件',
    createString: '{time} 创建',
    uploadString: '{time} 上传',
    updateString: '{time} 更新',
    editorString: '{ID} 于 {time} 更新',
    filter: '筛选',
    sort: '排序',
    restore: '恢复默认',
    all: '全部',
    filterStatus: '模型状态',
    filterCad: '已申请CAD',
    filterMark: '标记状态',
    filterMarked: '已标记',
    fiterOwner: '所有者',
    filterSelfOwner: '自己所有',
    filterShared: '他人分享',
    updateNewest: '最近更新',
    createNewest: '最近上传/创建',
    searchHint: '输入关键字',
    pagePre: '上一页',
    pageNext: '下一页',
    pageFirst: '第一页',
    pageLast: '最后一页',
    operate: '操作',
    share: '分享',
    selectAll: '全选',
    rename: '修改名称',
    moveTo: '移入文件夹',
    tipSample: '当前无任何模型数据，请从App端上传模型至浏览器，或点击下方按钮体验示例模型。',
    btnSample: '体验示例模型',
    noFile: '当前文件夹中没有文件',
    noResult: '没有符合您搜索条件的结果。 请更改搜索条件。',
    noSearchResult: '建议尝试更改关键字、检查输入错误或调整筛选器。',
    shareSpace: '共享空间',
    teamSpace: '团队空间',
    editFolder: '编辑文件夹',
    folderName: '文件夹名称',
    folderNameHint: '请填写文件夹名称',
    folderDesc: '文件夹简介',
    folderDescHint: '请填写简介',
    folderDescLimit: '请输入100字以内的简介',
    editModel: '编辑模型名称',
    modelName: '模型名称',
    modelNameHint: '请填写模型名称',
    dataSize: '模型大小',
    shareString: '{ID} 于 {time} 分享',
    id: {
      log: '客户操作日志',
      logCompany: '{company}操作日志',
      Invoice: '发票{订单号}',
      MemberList: '{会社名}成员列表{YYYYMMDD}',
      PlanOrderList: '套餐订单列表{YYYYMMDD}',
      CADOrderList: 'CAD订单列表{YYYYMMDD}',
      CustomerInformationList: '客户信息列表{YYYYMMDD}',
      AccountList: '账号列表{YYYYMMDD}',
      UserBatchImportTemplate: '批量导入成员模板',
      transactionFiles: '凭证文件{number}',
      memberList: '成员列表{YYYYMMDD}',
      planOrderList: '套餐订单列表{YYYYMMDD}',
      cadOrderList: 'CAD订单列表{YYYYMMDD}',
      customerInformationList: '客户信息列表{YYYYMMDD}',
      companyMemberList: '{company}成员列表{YYYYMMDD}',
      accountList: '账号列表{YYYYMMDD}',
      userBatchImportTemplate: '批量导入成员模板',
      invoice: '请求书{number}'
    },
    noResultTitle: '未找到结果',
    code: {
      get: '获取嵌入代码',
      mode: '加载方式',
      manual: '手动加载',
      auto: '自动加载',
      copy: '复制嵌入代码',
      language: '显示语言',
      copySuccess: '代码已复制'
    },
    delete: {
      title: '确定要删除此模型吗？',
      prompt: '删除后，拥有模型权限的成员将无法再访问这些模型。',
      noAuth: '部分文件无删除权限，请重新选择'
    },
    deleteFolder: {
      title: '确定要删除此文件夹吗？',
      prompt: '删除后，您和其他成员将无法访问所选文件夹内的模型。'
    },
    mark: {
      cancledToast: '未标记',
      markedToast: '已标记'
    },
    copy: '复制',
    import: {
      button: '导入模型',
      title: '导入模型',
      tip1: '选择或拖拽单个3D文件导入',
      tip2: '支持格式',
      tip3: '最大支持500M。如果您的文件包含素材图片，请压缩为zip再导入',
      select: '选择文件',
      reSelect: '重新选择文件',
      release: '释放鼠标，添加文件',
      refresh: '文件正在导入中，请勿刷新或关闭页面，否则导入将失败',
      fail: '导入失败！请重新导入模型',
      prompt: '文件正在导入中，刷新后导入将失败，确认刷新吗？',
      error: {
        checkNet: '导入失败，请检查网络后重试',
        parsingFailed: '模型解析失败，请检查后重新导入',
        system: '系统处理异常，请稍后重试',
        invalidFile: '未在压缩包中识别到有效的模型文件，请检查后重新导入'
      }
    },
    itemsPerPage: '每页数量',
    mySpace: '个人空间',
    folderEmptyDesc: '暂未填写简介',
    sortBy: {
      updateTimeDescending: '更新时间（近→远）',
      updateTimeAscending: '更新时间（远→近）',
      createTimeDescending: '上传/创建时间（近→远）',
      createTimeAscending: '上传/创建时间（远→近）',
      firstletterDescending: '名称首字母（A→Z）',
      sizeDesc: '模型大小（大->小）',
      sizeAsc: '模型大小（小->大）'
    },
    creator: '上传/创建者',
    createOrUploadTime: '上传/创建时间',
    noFound: {
      text: '未找到名称含有{0}的文件夹，请尝试其他关键词'
    },
    move: {
      noAuth: '部分文件无移动权限，请重新选择'
    },
    modelNum: '{n}个模型'
  },
  filemodal: {
    deletAll: '确认删除吗？',
    selectMove: '选择移动位置',
    move: '移动到此',
    noData: '当前无数据',
    share: '分享模型链接',
    copyLink: '复制链接',
    copySuccess: '链接复制成功！',
    shareTip: '1. 拥有Scanat Web权限的用户：可以查看和编辑模型。所做的更改将实时同步到原始共享模型中。\\n\n2. 没有Scanat Web权限的用户：可以查看和编辑模型，但所做的更改不会应用或保存到原始的共享模型中。',
    moveSuccess: '移动成功！',
    folderSuccess: '文件夹创建成功！',
    changeSuccess: '已变更',
    noSpecialSymbol: '不允许使用特殊符号',
    deleteComfirm: '确认删除吗？删除后将无法恢复',
    cannotEdit: '该文件已被删除，无法编辑',
    resetLink: '确定重置链接吗？重置后，之前的链接将无法访问。',
    moveFileTitle: '移动文件',
    moveFileDesc: '移动后，所选文件将继承目标文件夹的协作者与权限设置，原协作者可能无法访问。',
    moveFolderTitle: '移动文件夹',
    moveFolderDesc: '移动后，当前文件夹将继承目标文件夹的协作者与权限设置，原协作者可能无法访问。',
    moveModelTitle: '移动模型',
    moveModelDesc: '移动后，当前模型将继承目标文件夹的协作者与权限设置，原协作者可能无法访问。',
    sharePromptOld: '1.拥有ScanatWeb权限的用户：可同时查看和编辑模型。\n2.没有ScanatWeb权限的用户：可以查看模型，但无法同时进行编辑。',
    cannotAccess: '该文件已被删除，无法访问'
  },
  language: {
    ja: '日本語',
    en: 'English',
    cn: '简体中文'
  },
  profile: {
    basic: '基本信息',
    account: '账号',
    name: '姓名',
    company: '所属会社',
    superManage: '超级管理员',
    manage: '管理员',
    member: '普通成员',
    deregisterAccount: '注销账号',
    deregisterTip: '1. 您的全部个人信息与历史信息将无法找回。\\n\n2. 您的所有模型记录、交易记录等将被全部删除且无法恢复。\\n\n3. 若您是超级管理员，且团队中仍有账户未移除，则无法注销。',
    deregisterWarningCo: '注销后将删除企业的所有模型记录且无法找回，',
    deregisterWarningUser: '注销后将删除您的所有模型记录且无法找回，',
    deregisterConfirm: '确定注销吗？',
    deregisterfail1: '您好，您的团队中仍有',
    deregisterfail2: '账号',
    deregisterfail3: '在使用，请至团队管理页面，将成员移除后再注销。',
    deregisterComplete: '您已完成注销',
    continue: '继续注销',
    manageAccount: '去管理账号'
  },
  company: {
    setting: '公司信息',
    basic: '基本信息',
    expand: '扩展信息',
    name: '公司名称',
    nameInput: '请填写公司名称',
    owner: '公司负责人',
    ownerLastname: '姓',
    ownerName: '名',
    ownerSexual: '请选择性别',
    ownerMale: '男',
    ownerFemale: '女',
    numberInput: '请填写电话号码',
    zipcode: '邮编',
    zipcodeInput: '请填写邮编',
    address: '地址',
    addressProvince: '州/省',
    addressCity: '市/镇/村',
    addressDistrict: '地区名称',
    addressDetails: '详细地址',
    industry: '行业分类',
    industrySelect: '请选择行业分类',
    industryArchi: '建筑业',
    industryManu: '制造业',
    industryEstate: '房地产·商品租赁',
    industryTel: '信息和通信业',
    industryElectric: '供电·供气·供热和供水',
    industryTrans: '交通运输 · 邮政服务',
    industryInfo: '信息处理服务',
    industryStudy: '学术、研究、专业和技术服务',
    industryRetail: '批发和零售业',
    industryResearch: '研究行业',
    scale: '员工规模',
    scaleSmall: '0-50',
    scaleMedium: '50-100',
    scaleLarge: '100人以上',
    scaleSelect: '请选择员工规模',
    capital: '注册资本',
    capitalInput: '请填写注册资本',
    capitalUnit: '日元',
    service: '主营业务',
    serviceInput: '请填写主营业务',
    domain: '域名',
    domainDesc: '*ScanatWeb允许您将模型详情页面嵌入至第三方平台。您可以在此添加第三方平台的域名，模型嵌入代码将只在您设置的域名上生效。您最多可添加10个域名。',
    inputDomain: '请输入域名',
    domainError: '请输入有效域名',
    domainManage: '域名管理',
    domainList: '域名列表',
    addDomain: '新增域名',
    editDomain: '编辑域名',
    deleteDomain: '删除域名',
    deleteDomainTip: '确认删除域名吗？删除后模型嵌入代码将无法在该域名访问。',
    inputCorrectPhone: '请输入正确的电话号码',
    inputNumber: '请输入数字',
    domainIframeError: '此域名未被授权，无法展示',
    ownerNameTitle: '姓名',
    ownerGenderTitle: '性别',
    ownerPhoneTitle: '电话',
    DomainExsit: '域名已存在，请重新输入'
  },
  card: {
    manage: '信用卡管理',
    number: '卡号',
    dueDate: '到期时间',
    status: '状态',
    owner: '持卡人',
    statusNormal: '正常',
    statusExpired: '已过期',
    default: '默认信用卡',
    setDefault: '设为默认',
    create: '新增信用卡',
    inputNumber: '请填写卡号',
    validity: '有效期限',
    inputMonth: '请填写月份',
    inputYear: '请填写两位数年份',
    securityCode: '安全码',
    inputSecurityCode: '请填写安全码',
    inputOwner: '请填写持卡人姓名',
    errorNumber: '请填写16位整数',
    errorMonth: '请填写01～12月份',
    errorYear: '请填写有效年份',
    errorSecurity: '请填写3位安全码',
    errorOwner: '请填写持卡人',
    errorExpired: '您的信用卡已过期，请检查有效期或更换卡片',
    delete: '删除信用卡',
    deleteConfirm: '确认删除尾号{number}的信用卡吗？',
    deleteComplete: '信用卡已删除',
    defaultComplete: '设为默认成功',
    emptyTitle: '当前未添加信用卡信息',
    emptyDesc: '请点击下方添加按纽添加信用卡',
    bind: '当前扣费信用卡',
    inputMonthYear: '月/年',
    error: {
      InvalidNumber: '您的卡号无效',
      tooShortNumber: '您的银行卡卡号不完整。',
      invalidDate: '您银行卡的到期年份无效。',
      incompleteDate: '您银行卡的有效期不完整。',
      expiredDate: '您银行卡的到期年份是过去的年份。',
      invalidSecurityCode: '您银行卡的安全码不完整。'
    }
  },
  home: {
    title: '首页',
    modelAmount: '总模型数（个）',
    memberAmount: '成员数（个）',
    orderAmount: '产生订单（个）',
    quick: '快捷入口',
    completeInfo: '完善企业信息',
    team: '组建团队',
    cowork: '模型协作',
    order: '查看订单',
    read: '入门必读',
    back: '返回主页'
  },
  plan: {
    a: 'Plan A 体验套餐',
    b: 'Plan B 基础套餐',
    c: 'Plan C 商务套餐',
    d: 'Plan D - 企业套餐',
    selectPlan: '选择套餐计划',
    id: 'ID数',
    app: '应用版',
    appWeb: '应用+网页版',
    price: '{price}円起',
    none: '当前无套餐',
    now: '当前套餐',
    statusActive: '订阅中',
    statusUnactive: '待生效',
    end: '已结束',
    planDetail: '套餐详情',
    idMoreThan: '人起',
    bApp: 'Plan B 基础套餐（应用版）',
    bAll: 'Plan B 基础套餐（应用版+Web版）',
    aYearText: '与月付相比优惠24,000日元',
    unSelected: '未选择任何套餐'
  },
  order: {
    list: '订单记录',
    plan: '套餐订单',
    cad: 'CAD订单',
    statusUnpay: '未支付',
    trial: '可提前试用',
    statusPaid: '已支付',
    statusCancel: '已取消',
    statusComplete: '已完成',
    statusProcessing: '进行中',
    searchHint: '输入订单号/套餐名搜索',
    number: '订单号',
    name: '套餐名',
    payMethod: '订阅方式',
    payMonth: '月付',
    payYear: '年付',
    switchPayMethod: '切换订阅方式',
    switchPay: '切换订阅方式',
    switchMonthTip: '确认将当前A套餐的订阅方式修改为【月付】吗？',
    switchYearTip: '确认将当前A套餐的订阅方式修改为【年付】吗？',
    currentPeriod: '当前套餐周期',
    nextPeriod: '下一套餐周期',
    periord: '服务时间',
    selectSeat: '选择席位数',
    seat: '席位数',
    seatAdded: '新增席位',
    seatAddSum: '新增席位数',
    seatAddTime: '席位加入时间',
    selectTime: '请选择时间',
    seatPeople: '{n}人',
    seatUnactive: '{n}个席位待生效',
    seatTip: '此处您所选择的席位数量为该团队可用席位总数，如您选择 10， 则团队可用席位总数为10。',
    packageCount: '套餐数',
    packageCountTip: '选择购买的套餐数量',
    additionalIdCount: '追加ID数',
    additionalIdCountTip: '在套餐基础ID数之外额外购买的ID数量',
    totalIdCount: '合计{count}个ID',
    packageBaseIdCount: '所选套餐包含{count}个ID',
    seatOver: '成员超额提醒',
    seatOverTip: '您好，您当前团队有{n}位成员，请确保您的购买席位数大于{n}，或至团队管理页面移除部分成员后再来购买。',
    memberUsed: '使用中的成员',
    deleteMemble: '去移除成员',
    cancelTip: '{date}取消',
    expandSeat: '席位扩容',
    purchase: '购买套餐',
    purchaseNow: '立即购买',
    levelUp: '升级版本',
    renewal: '续费',
    buy: '购买',
    changeTime: '修改服务时间',
    olderTime: '原服务时间',
    newTime: '新服务时间',
    startTime: '开始时间',
    endTime: '结束时间',
    updateTime: '升级时间',
    contactService: '联系客服',
    changeCard: '更改扣费信用卡',
    SelectCard: '请选择扣费信用卡',
    cancel: '申请取消订阅',
    cancelTip1: '取消订阅后，套餐在{date}到期后将不再续费，届时该会社下所有成员将无法使用系统，确定取消吗？',
    cancelTip2: '取消订阅后，将不再尝试自动扣费，该会社下所有成员将无法使用系统，确定吗？',
    revokeCancellation: '撤回取消订阅',
    revokeTip: '确认撤回取消订阅操作吗？撤回后您可以重新取消订阅',
    noPlan: '当前无可用套餐',
    newPlan: '变更后套餐',
    learn: '了解套餐',
    learnMore: '查看套餐详情',
    confirmOrder: '确认订单',
    orderInfo: '订单信息',
    planStart: '套餐开始时间',
    planStartInstant: '付款完成后即可使用',
    item: '商品',
    itemName: '商品名称',
    modelName: '模型名称',
    diagramType: '图纸类型',
    category: '类别',
    totalItem: '数量',
    unitPriceYen: '单价',
    totalSumYen: '总金额',
    unitPrice: '单价',
    totalSum: '总金额',
    unusedSum: '原套餐未使用金额',
    quickSum: '小计',
    tax: '税费（10%）',
    payableSum: '应付金额',
    payableSumUnit: '应付金额（日元）',
    submit: '提交订单',
    confirmSubmit: '确认并提交订单',
    createUser: '创建人',
    createTime: '创建时间',
    paidTime: '付款时间',
    giveTime: '交付时间',
    paidStatus: '付款状态',
    cadStatus: 'CAD制作状态',
    orderSum: '订单金额',
    status: '状态',
    leftTime: '剩余支付时间',
    switchTipYear: '将于{date}切换为年付',
    switchTipMonth: '将于{date}切换为月付',
    autoFail: '自动扣费失败',
    cardFailTip: '信用卡扣费失败，明日将重试，请尽快更换您的扣费信用卡。',
    toSwitch: '去更换',
    details: '订单详情',
    type: '订单类型',
    sumTip: '总金额=套餐单价*新增席位数*剩余天数/{n}天',
    unusedTip: '原套餐未使用金额=旧套餐单价*原席位数*未使用天数/{n}天',
    priceTip: '按时长折算后单价，单价=套餐原单价*剩余使用天数/{n}天',
    oldPlan: '原套餐',
    unusedTime: '未使用天数',
    actionDetail: '详情',
    checkDetail: '查看详情',
    actionPay: '去支付',
    actionCancel: '取消订单',
    cancelConfirm: '确认取消订单吗？',
    actionInvoice: '下载凭证',
    actionDiagram: '下载图纸',
    submitOrder: '提交订单',
    payOrder: '支付订单',
    completeOrder: '订单完成',
    applican: '申请人',
    appliTime: '申请时间',
    checkCancel: '查看取消原因',
    cancelTime: '取消时间',
    cancelReason: '取消原因',
    useTip: '付款成功即可使用',
    unpaidTip: '您有一笔套餐订单仍未支付，请支付或咨询服务商',
    existPlantip: '您已购买套餐{plan}，无法购买新的套餐。',
    unactivePlantip: '您已购买套餐{plan}，还未到生效时间，套餐的生效时间为{date}。',
    checkCurrentPlan: '查看当前套餐',
    leftDay: '天',
    leftHr: '小时',
    leftMin: '分钟',
    leftSec: '秒',
    expireTip: '超过该时间未支付，订单将会被自动取消',
    purchaseSuccess: '恭喜你，购买成功',
    currentSeat: '当前席位数',
    seatExpandExceed: '当前套餐最多可购买{max-seat}个席位，您当前已购买{exist-seat}个席位，最多可扩容{left-seat}个席位，请修改后重新提交。',
    noPlanError: '当前无订阅中的套餐，不允许进行扩容操作。请联系客户经理取消订单后重新购买套餐。',
    planType: '订购套餐',
    overTime: '已超过支付期限',
    itemList: '商品清单',
    system: '系统',
    selectNumber: '选择数量',
    numberOfPlan: '套餐数',
    numberOfID: '追加ID数',
    numberTip1: '合计{detail0}个ID',
    numberTip2: '所选套餐包含{detail0}个ID',
    card: {
      '3DsTip': '信用卡自动扣费需要3Ds认证，系统已发送认证邮件，请检查您的邮件并完成认证。'
    },
    complete: '完成申请'
  },
  cad: {
    statusProcessing: 'CAD绘制中',
    statusComplete: 'CAD绘制完成',
    submit: '提交申请',
    completeTime: '约2～4天',
    create: 'CAD绘制',
    delivery: '交付图纸',
    model: '模型',
    innerWall: '内壁厚度',
    outerWall: '外壁厚度',
    deliveryFormat: '图纸交付格式',
    usage: '建筑类型',
    type: '图纸类型',
    attachment: '现有图纸',
    application: 'CAD制图申请',
    usageResidential: '住宅',
    usageOffice: '办公室',
    usageShop: '商店和机构',
    usageOthers: '其他',
    fileCad: 'CAD文件',
    filePdf: 'PDF文件',
    diagramFloorplan: '平面图',
    diagramCeiling: '天花板图',
    diagramElevation: '立面图',
    tipProcessing: '图纸绘制中，请耐心等待…'
  },
  pay: {
    payment: '支付方式',
    detailCard: '支付详情-信用卡',
    detailInvoice: '支付详情-请求书',
    orderPay: '订单支付',
    selectMethod: '选择支付方式',
    creditcard: '信用卡',
    invoice: '请求书',
    invoiceSendTip: '请求书将会发送至您的邮箱{mail}，请将资金转入以下账户：',
    invoiceResendTip: '请求书已发送至您的邮箱{mail}，请将资金转入以下账户：',
    bank: '银行',
    banCode: '银行编号',
    bankName: '支行名称',
    bankNumber: '支行编号',
    accountType: '账户类型',
    accountOwner: '账户持有人',
    accountNumber: '账户号码',
    sendInvoice: '发送请求书',
    noInvoice: '没收到请求书？',
    resendInvoice: '再次发送请求书',
    InvoiceSent: '请求书发送成功',
    toPay: '前往支付',
    agreement: '同意《购买协议》',
    payLoading: '正在支付，请稍候...',
    payJump: '支付处理中，即将跳转至订单页',
    unlimited: '无限制',
    alert: '该订单需要您线下转账，请检查您的历史邮件。若未收到转账信息或有其他问题，请联系您的客户经理。'
  },
  team: {
    member: '成员管理',
    status: '状态',
    statusActive: '使用中',
    statusUnactive: '未激活',
    addMember: '添加成员',
    deleteMember: '移除成员',
    deleteMemberTip: '移除成员后，该成员将无法访问您的会社，该成员已上传至云端的模型将不会丢失。确定移除吗？',
    addMultiMember: '批量添加成员',
    memberFormDownload: '点击下载「用户批量导入模版表格」',
    addMultiMemberTip: '1. 下载「用户批量导入模版表格」；\\n\n2. 打开模板，请使用纯文本或数字将对应字段信息输入或粘贴进本表；\\n\n3. 点击「上传表格」按钮，选择刚刚完成的用户信息表格并上传后，点击右下方【确认导入】按钮即可。\\n\n注：最多允许导入100条数据，若表格数据超过100条，所有数据均无法被导入',
    errorNoFile: '请上传文件',
    usedSeat: '已用席位',
    seat: {
      total: '总席位',
      noSeat: '无剩余可用席位，无法操作',
      manageSeat: '席位分配',
      onSuccess: '分配席位成功',
      offSuccess: '关闭席位成功'
    },
    model: '总模型数',
    cloudModel: '云端模型数',
    name: '姓名',
    inputLastname: '请输入姓',
    inputname: '请输入名',
    mail: '邮箱',
    mailAddress: '邮箱地址',
    inputEmail: '请填写邮箱地址',
    emptyEmail: '请填写邮箱！',
    errorEmail: '邮箱格式有误，请检查后重新填写',
    activeAccount: '激活账号',
    activeAccountTip: '该成员将收到激活邮件，确认激活吗？',
    lastLogin: '最近登录时间',
    deleteMultiMember: '批量移除成员',
    deleteMultiMemberTip: '移除成员后，所选成员将无法访问您的会社，成员已上传至云端的模型将不会丢失。确定移除吗？',
    editMember: '编辑成员',
    contactPhone: '客服联系方式：',
    contactEmail: '客服邮箱：',
    cannotRemoveAdminOrSelf: '无法移除超级管理员或自己',
    removeSuccess: '成员移除成功',
    statusDisabled: '停用中',
    role: {
      owner: '所有者',
      superManger: '超级管理员',
      manager: '管理员',
      ScanatUser: 'Scanat用户',
      viewUser: '浏览用户',
      name: '角色',
      updateSuccess: '修改角色成功',
      noRole: '无角色'
    },
    operate: {
      enable: '启用',
      disable: '禁用'
    },
    prompt: {
      buyScanatWeb: '已购买Scanat web服务'
    },
    add: {
      chooseRole: '请选择角色',
      manageSeat: '席位分配',
      seatTip1: '关闭后该账号将不占用席位',
      seatTip2: '开启后该账号将占用1个席位'
    },
    enable: {
      noRight: '无启用该账号的权限',
      tip: '启用后，该账号可以正常使用，确定启用吗？',
      success: '启用成功',
      noPlan: '公司不在订阅中，无法启用账号'
    },
    disable: {
      noRight: '无禁用该账号的权限',
      tip: '禁用后，该账号将无法使用，系统不会删除账号的数据，禁用后可再次启用，确认禁用吗？',
      success: '禁用成功'
    },
    statusDisabledTxt: '已禁用',
    seatTip: '分配席位后，可使用Scanat服务',
    delete: {
      noRight: '无删除该账号的权限'
    }
  },
  survey: {
    title: 'Scanat 解约申请',
    desc: '感谢您一直以来对 Scanat 的使用与支持。\n如您希望申请解约，请填写以下表格中的必要事项后提交。\n我们将在收到表格后的工作日，由负责人通过电话或电子邮件与您联系。',
    questionReason: '解约原因（可多选）',
    reason1: '测量精度低',
    reason2: '拍摄或操作方法困难',
    reason3: '使用频率低',
    reason4: '功能不足',
    reason5: '费用高',
    reason6: '支持体系不完善',
    questionApp: '2. 您还用过哪些扫描系统？（多选）',
    app1: '3D Scanner',
    app2: 'Canvas',
    app3: 'Metascan',
    app4: 'Modelar',
    app5: 'Matterport',
    app6: 'OpalUI',
    app7: 'Polycam',
    app9: 'Scaniverse',
    app10: 'Sitescope',
    questionRecommend: '3. 您有多大意愿将Scanat推荐给需要3D扫描的朋友？',
    descRecommend: '* 0～10代表您向朋友推荐Scanat的意愿程度，0代表「非常不愿意」，10代表「非常愿意」',
    questionOther: '意见或建议',
    descOther: '如果您对 Scanat 有任何需求，或希望添加的功能、希望改进的地方，欢迎填写。（自由填写栏）',
    submit: '提交申请',
    error: '请填写该问题',
    complete: '申请提交成功',
    thanks: '感谢您的宝贵时间，nat将尽快处理您的申请！',
    profileTitle: '您的详细信息（所有字段必填）',
    profileOwnerHint: '例：山田太郎',
    profilePhoneHint: '例：05017807133',
    profileMailHint: '例：scanat{\'@\'}natincs.com',
    profileOwnerEmpty: '请输入主担当者',
    profilePhoneEmpty: '请输入电话',
    profileMailEmpty: '请输入邮箱',
    profilePhoneError: '请输入有效的电话',
    profileMailError: '请输入有效的邮箱',
    reasonOtherEmpty: '内容不能为空，请输入具体内容',
    reasonEmpty: '请选择解约理由',
    questionReasonDesc: '请勾选所有适用的选项',
    reason7: '部门或负责人变更',
    reason8: '更换为其他公司产品',
    contactTip: '如有疑问，请通过下方方式与我们联系。',
    contact: '【联系方式】\n- 联系电话：050-1780-7133\n- 联系邮箱：cs{\'@\'}natincs.com',
    waiting: '等待处理中...',
    submited: '您已提交取消订阅申请，请耐心等待\n- 联系电话：050-1780-7133\n- 联系邮箱：cs{\'@\'}natincs.com',
    submitedOther: '{id}已提交取消订阅申请，请耐心等待\n- 联系电话：050-1780-7133\n- 联系邮箱：cs{\'@\'}natincs.com'
  },
  log: {
    title: '操作日志',
    searchHint: '输入账号搜索',
    remark: '※ 可查看1年内操作日志',
    account: '操作账号',
    time: '操作时间',
    system: '所属系统',
    page: '操作页面',
    action: '事件名称',
    detail: '详情',
    ip: 'IP地址',
    device: '操作设备',
    overtimeError: '所查询的日志时间已经超过一年，请重新选择时间',
    noUserError: '未找到该账号'
  },
  toast: {
    noMovePermission: '没有目标文件夹的移动权限，请重新选择',
    levelExceed: '部分文件夹移动后超过2级层级，请重新选择',
    exist: '已经存在于该文件夹中',
    cannotMove: '不可移动至当前文件夹或子文件夹中',
    depth: {
      exceed: '移动后超过10级层级，请重新选择'
    }
  },
  share: {
    accountShare: '通过账号分享',
    linkShare: '通过链接分享',
    searchHint: '输入联系人账号搜索',
    searchEmpty: '未找到符合的联系人。\n请尝试其他关键词搜索。',
    limits: '权限',
    people_amount: '{n}人',
    read: '仅查看',
    edit: '可编辑',
    manage: '可管理',
    resetLink: '重置链接',
    overwritePw: '覆盖现有密码',
    unSaveTip: '请先取消或保存密码',
    title: {
      privateLink: '私密链接',
      encryptedLink: '加密链接',
      publicLink: '公开链接',
      changeLinkPassword: '修改链接密码'
    },
    desc: {
      privateLink: '- 仅团队内成员可访问',
      encryptedLink: '- 获得密码的人可访问',
      publicLink: '- 所有人均可访问'
    },
    hint: {
      changeLinkPassword: '请输入长度4～20的数字或字母'
    },
    toast: {
      changeModeSuccess: '权限设置成功',
      noPermission: '仅模型所有者与管理员可修改',
      save: '请先取消或保存密码',
      noPermissionNew: '需要该模型的可编辑或可管理权限'
    },
    alert: {
      title: {
        changeToPublic: '提示'
      },
      info: {
        changeToPublic: '该功能开启后，互联网上获得链接的人都能够访问模型'
      }
    },
    copy: '已复制链接，将其粘贴到浏览器中即可与他人分享。',
    link1: '{detail0}',
    link2: 'Scanat模型链接：{detail0}\n密码：{detail1}',
    copyLink: '复制链接',
    modelNotFound: '模型「{modelName}」已被删除',
    link: {
      noModel: '模型不存在',
      noModelTip: '请检查链接是否正确'
    },
    privateLink: {
      linkFail: '链接已失效',
      tip: '当前登录账号 {id}，您可以联系 {admin_id} 获取新的链接',
      contactManage: '没有访问权限，请联系您的管理员',
      limitPermission: '当前登录账号为{id},没有权限访问模型'
    },
    encryptedLink: {
      needPassword: '访问该模型需要密码',
      errorPassword: '请输入正确的密码',
      go: '前往',
      placeholder: '请输入密码'
    }
  },
  member: {
    searchHint: '输入成员账号搜索',
    searchEmpty: '未找到符合的成员，请尝试其他关键词搜索',
    addMember: '添加成员',
    owner: '所有者',
    admin: '超级管理员',
    outsider: '外部人员'
  },
  import: {
    model: '导入模型',
    fail: '导入失败！',
    reimport: '重新导入模型',
    importGuide: '选择或拖拽单个3D文件导入',
    importFormat: '支持格式：OBJ/GLTF/GLB/DRC/STL/PLY/DAE/FBX/SKP/USDZ/DXF/ZIP\n如果您的文件包含素材图片，请压缩为ZIP导入',
    releaseMouse: '释放鼠标，添加文件',
    localFile: '选择文件',
    reSelect: '重新选择文件',
    wrongFormat: '您选择的文件格式不支持，请重新选择',
    fileSizeLimit: '文件大小超过限制，请重新导入'
  },
  period: {
    lastWeek: '近1周',
    lastMonth: '近1个月',
    lastYear: '近1年'
  },
  menu: {
    company: '公司信息',
    log: '操作日志',
    order: '订单记录',
    team: '团队管理'
  },
  title: {
    team: '团队管理',
    company: '公司信息',
    order: '订单记录',
    log: '操作日志',
    buy: '购买商品',
    pay: '支付订单',
    paySuccess: '支付成功',
    orderInfo: '订单详情',
    land: '选择您要使用的服务',
    link: {
      useless: '链接失效',
      notExist: '链接不存在'
    }
  },
  SUCCESS: '操作完毕',
  VALIDATE_FAILED: '参数验证失败。',
  UNAUTHORIZED: '尚未注册或令牌已过期。',
  INVALID_PASSWORD: '用户名或密码错误。',
  UNAVAILABLE: '注册后账户需要在法人合同签订后由销售代表进行激活。如果您有意愿，请联系',
  FORBIDDEN: '未授予必要的权限。',
  POSTCODE_NOT_EXIST: '邮政编码不存在。',
  NOT_REGISTERED: '此邮箱地址未注册。',
  VERIFICATION_CODE_ERROR: '验证码不正确。',
  VERIFICATION_CODE_EXPIRE: '验证码已过期。',
  USER_NOT_EXIST: '此用户不存在。',
  CRM_ACCOUNT_NOT_EXIST: '账户不存在，请联系客服。',
  USER_EXIST: '此用户已存在。',
  CONFIRM_PASSWORD: '输入的密码不匹配。',
  FILE_UPLOAD_KEY_GET_FAIL: '无法获取密钥。',
  MODEL_NOT_BELONG: '该模型不属于您。',
  FAILED: '操作失败',
  REQUEST_FREQUENTLY: '操作过于频繁，请稍后再试。',
  FILE_SHARE_ERROR_DEL: '由于文件已被删除，共享失败',
  FILE_SHARE_ERROR_UNAUTHORIZED: '没有权限进行此操作',
  FILE_SHARE_ERROR_EMAIL_NOT_EXISTS: '用户ID不存在',
  FILE_SHARE_ERROR_UNKNOWN: '未知错误',
  FILE_SHARE_ERROR_REPEAT_SHARING: '模型已被发送给该用户',
  FILE_SHARE_ERROR_SELF: '无法将模型发送给自己',
  FILE_SHARE_UPDATE_FAIL: '更新失败。找不到共享的文件',
  FILE_DOWNLOAD_ERROR_DEL: '由于文件已被删除，无法下载',
  FILE_SHARE_DEL_FAIL: '由于没有共享的模型，无法删除',
  FILE_SHARE_DEL_FAIL_NO_AUTHORITY: '无法删除共享的模型',
  CREDIT_CARD_PAY_ERROR: '订阅恢复失败',
  CREDIT_CARD_PAY_FAIL_BY_ERROR_FILE_KEY: '卡支付失败，原因：数据不存在！',
  PERMITS_CONVERT_FAIL: '订阅恢复失败',
  PERMITS_CONVERT_FAIL_USER_NULL: '订阅恢复失败',
  APP_TRANSLATION_INVALID: '用户不存在',
  APP_TRANSLATION_HISTORY_GET_FAIL: '获取订阅数据失败',
  APP_TRANSLATION_STATUS_GET_FAIL: '获取订阅数据失败',
  FILE_UPLOAD_FILE_PATH_EMP_ERROR: '无法更新：请输入文件路径。',
  FILE_UPLOAD_FILE_DB_FAIL_ERROR: '无法更新：模型记录出现错误。',
  APP_TOKEN_GET_FAIL: '获取参数失败',
  APP_IP_ADDRESS_NOT_ALLOW: '该IP地址无法被访问',
  CONTACT_ALREADY_EXIST: '联系人已存在，请不要重复添加。',
  ACCOUNT_PLAN_NOT_EXIST: '尚未购买套餐计划',
  ACCOUNT_PLAN_TYPE_ERROR: '套餐类型信息有误',
  ACCOUNT_PLAN_DOWNGRADE: '不能将套餐降级',
  ACCOUNT_PLAN_PREPAY_MONTH_ERROR: '套餐信息有误',
  ACCOUNT_PLAN_PREPAY_MONTH_NOT_OVER: '在预付款期间结束之前，无法更改套餐',
  CUSTOMER_FINCODE_CUSTOMER_ID_NOT_EXIST: '找不到用户的FincodeID',
  FINCODE_PLAN_ID_NOT_EXIST: 'FincodeID不存在',
  CUSTOMER_NAME_DUPLICATE: '用户名已存在，请不要重复添加',
  CUSTOMER_NAME_BLANK_NOT_ALLOW: '用户名不能为空',
  ACCOUNT_NOT_EXIST: '用户ID不存在',
  CUSTOMER_NOT_EXIST: '用户不存在',
  FINCODE_CARD_ID_BLANK_NOT_ALLOW: 'FincodeID不能为空',
  CUSTOMER_NOT_BOUND_TO_ACCOUNT_PLAN: '用户未与任何套餐计划关联',
  CUSTOMER_ACCOUNT_PLAN_NOT_IN_EFFECT: '付款请求已发送，正在确认扣款结果，请稍等！',
  ACCOUNT_IN_USE_HAS_REACHED_MAX: '可用的ID数量已达到上限',
  ACCOUNT_IN_USE_AND_ADD_ACCOUNT_EXCEED_MAX: '新增的ID数与当前使用的ID数总和已超过套餐的ID数量上限',
  ACCOUNT_EMAIL_NOT_ALLOW_DUPLICATES: '账户的邮箱地址不能重复注册',
  ACCOUNT_EMAIL_ALREADY_EXISTS: '邮箱地址已存在',
  ACCOUNT_LIST_CANNOT_BE_EMPTY: '账户集合不能为空',
  FREEE_TOKEN_GET_ERROR: '发生了Freee的认证错误',
  FREEE_API_REQUEST_ERROR: '向Freee的API发送请求时发生了错误',
  FREEE_INVOICE_LIST_ERROR: '向Freee的API发送请求获取发票列表时发生了错误',
  FREEE_INVOICE_DETAIL_ERROR: '向Freee的API发送请求获取发票详情时发生了错误',
  FREEE_ADD_INVOICE_ERROR: '向Freee的API发送请求添加发票时发生了错误',
  FREEE_ADD_PARTNER_ERROR: '向Freee的API发送请求添加客户时发生了错误',
  FREEE_UPDATE_PARTNER_ERROR: '向Freee的API发送请求更新客户时发生了错误',
  FREEE_PARTNER_DETAIL_ERROR: '向Freee的API发送请求获取客户信息时发生了错误',
  FREEE_PARTNER_LIST_ERROR: '向Freee的API发送请求获取客户列表时发生了错误',
  ACCOUNT_PLAN_ORDER_NOT_EXISTS: '客户的合同套餐信息不存在',
  CUSTOMER_ALREADY_ADDED: '客户信息已存在',
  ORDER_NOT_EXIST: '订单不存在',
  ORDER_STATUS_ERROR: '订单状态错误',
  ORDER_PAYMENT_METHOD_NOT_ALLOW: '订单支付方式不支持',
  FINCODE_CUSTOMER_CARD_NOT_FOUND: 'Fincode卡不存在',
  FREEE_PARTNER_NOT_FOUND: 'Freee客户信息没有找到',
  CUSTOMER_ALREADY_BOUND_PLAN: '已发送付款请求，请勿重复发送',
  MY_USER_PHONE_NUMBER_ALREADY_EXISTS: '用户手机号码已存在',
  MY_USER_EMAIL_ALREADY_EXISTS: '用户邮箱已存在',
  ROLE_NAME_DUPLICATE: '角色名称不能重复',
  THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DISABLED: '有用户绑定该角色，不能禁用',
  THERE_ARE_USERS_BOUND_TO_THIS_ROLE_CANNOT_UPDATE_ITS_DEPT: '有用户绑定该角色，不能修改其部门',
  THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DELETED: '有用户绑定该角色，不能删除',
  ADD_DEPT_NOT_ALLOWED_UNDER_HEADQUARTERS: '总部下不允许添加部门',
  AGENCY_DEPT_MUST_SET_POSTAL_CODE_AND_ADDRESS_INFORMATION: '代理店部门必须设置邮编和地址信息',
  MOST_FIVE_DEPT_LEVELS: '部门最多五级，不允许添加部门',
  DEPT_NAME_ALREADY_EXISTS: '部门名称已存在',
  THE_DEPT_HAS_SUB_DEPT: '该部门存在下级部门，不允许删除',
  THERE_ARE_USERS_IN_THIS_DEPT: '该部门存在用户，不允许删除',
  THERE_ARE_ROLES_BOUND_TO_THIS_DEPT: '有角色绑定该部门，不允许删除',
  THERE_ARE_ACCOUNT_PLAN_BOUND_TO_THIS_DEPT: '该部门下存在账号套餐，不允许删除',
  CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_ADD: '客户名称已存在，不能新增',
  THE_DEPT_BOUND_TO_THE_CUSTOMER_DOES_NOT_EXISTS: '客户所绑定的部门不存在',
  CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_UPDATE: '客户名称已存在，不能修改',
  THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ACTIVATE_THE_ACCOUNT: '该客户未绑定账号套餐，不能激活账号',
  THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ACTIVATE_THE_ACCOUNT: '该客户的账号套餐未生效，不能激活账号',
  THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_BE_ACTIVATED: '已激活的账号数已达到套餐id数量上限，不能再激活账号',
  THE_NEW_CUSTOMER_IS_NOT_BOUND_TO_ANY_ACCOUNT_PLAN_THE_ACTIVATED_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: '新客户未绑定任何账号套餐，已激活的账号不能改到该客户名下',
  THE_ACCOUNT_PLAN_FOR_NEW_CUSTOMER_HAS_NOT_TAKEN_EFFECT_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: '新客户的账号套餐未生效，已激活的账号不能改到该客户名下',
  THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: '该客户未绑定账号套餐，不能追加激活状态的账号',
  THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: '该客户的账号套餐未生效，不能追加激活状态的账号',
  THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_ADD_ACTIVATED_ACCOUNT: '已激活的账号数已达到套餐id数量上限，不能追加激活状态的账号',
  THE_USER_OF_THE_AGENT_STORE_DOES_NOT_HAVE_PERMISSION_TO_VIEW_THE_CAD_ORDER_LIST: '代理店的用户没有权限查看CAD订单列表',
  CAD_ORDER_HAS_BEEN_COMPLETED_NOT_ALLOW_TO_UPLOAD_FILES: '订单已完结，不能再上传文件',
  CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_AGENT_STORE: '该角色属于本部，不能绑定只允许代理店访问才能访问的菜单',
  CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_HEAD_OFFICE: '该角色属于代理店，不能绑定只允许本部访问才能访问的菜单',
  THE_ACCOUNT_PLAN_IS_CURRENTLY_IN_USE_BY_A_CUSTOMER_AND_CANNOT_BE_DELETED: '该套餐有客户正在使用，不允许删除',
  THE_DEPT_WHERE_THE_EQUIPMENT_BELONGS_CANNOT_BE_A_AGENCY_STORE: '设备的归属部门不能为代理店',
  CUSTOMER_IS_CURRENTLY_USING_THIS_EQUIPMENT_CANNOT_BE_DELETED: '有客户正在使用该设备，不能删除',
  THE_STANDARD_QUOTATION_EQUIPMENT_FOR_ACCOUNT_PLAN_WITH_NORMAL_STATUS_IS_THE_CURRENT_EQUIPMENT_CANNOT_BE_DELETED: '有正常状态的账号套餐的标准报价设备是当前设备，不能删除',
  ADDING_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: '不允许新增客户，客户名称DB中已存在',
  ADDING_IS_NOT_ALLOWED_THIRD_PARTY_CUSTOMER_NAME_ALREADY_EXISTS: '不允许新增，第三方客户名称已存在',
  UPDATE_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: '不允许更新客户名称，客户名称DB中已存在',
  THE_CUSTOMER_HAS_AN_RESOLVED_ACCOUNT_PLAN_ORDER_CANNOT_MODIFY_ITS_DEPT: '客户有未解约的套餐订单，不能修改其所属部门',
  THE_CUSTOMER_HAS_AN_RESOLVED_EQUIPMENT_ORDER_CANNOT_MODIFY_ITS_DEPT: '客户有未解约的设备订单，不能修改其所属部门',
  CUSTOMER_INFO_NOT_ADDED: '您还没有添加客户信息',
  FREEE_PARTNER_NOT_EXIST: 'Freee中的客户信息不存在，请联系管理员确认',
  INVITATION_NOT_EXIST: '邀请不存在',
  INVITATION_STATUS_ERROR: '邀请状态错误',
  INVITATION_STATUS_INVALID: '邀请已经被撤销，请联系邀请客户管理员重新发送邀请',
  INVITATION_STATUS_EXPIRED: '邀请已经过期，请联系邀请客户管理员重新发送邀请',
  INVITATION_CHECK_CODE_WRONG: '邀请的验证码错误',
  CUSTOMER_ACCOUNT_PLAN_IN_EFFECT: '该账户已经是付费用户，请确认是否对错误的账户发出了邀请',
  CUSTOMER_NOT_ALLOW_CHANGE: '用户所属的客户不允许修改。',
  USER_STATUS_UNAVAILABLE: '您的账号尚未购买套餐，请去购买',
  USER_STATUS_AVAILABLE: '登录成功',
  USER_STATUS_ACCOUNT_EXPIRED: '您的帐号已过期，请重新续费',
  USER_STATUS_LOGOUT: '对应账号不存在',
  USER_STATUS_ACTIVE: '登录成功',
  USER_STATUS_TO_BE_EFFECTIVE: '您的帐号尚未生效，请联系贵公司的管理员%@处理',
  USER_STATUS_DEACTIVATE: '您的账号已被管理员停用，请联系贵公司的管理员%@处理',
  USER_STATUS_PRE_DEACTIVATE: '登录成功',
  USER_STATUS_PRE_ABNORMALITY: '账号异常，无法登录',
  AGENT_NOT_EXIST: '代理店不存在',
  AGENT_NAME_DUPLICATE: '代理店名重复',
  REQUEST_BOOK_NOT_EXIST: '请求书不存在',
  FILE_CREATE_FAIL: '创建文件失败',
  SALES_DATE_EMPTY: '请输入交易日期',
  EXTEND_PLAN_CONFIG_ERROR: '拓展套餐未配置，请联系开发人员',
  CAN_NOT_FIND_WEB_MODEL_KEY: '模型不存在',
  CAN_NOT_FIND_WEB_MODEL_FOLDER: '文件夹不存在',
  FOLDER_CANT_MOVE_INTO_SUB_FOLDER: '移动失败，文件夹不能被移动至二级文件夹',
  FOLDER_CONTAIN_SUB_FOLDER: '移动失败，所选文件夹中包含二级文件夹，无法被移动至其他文件夹',
  WEB_MODEL_ALREADY_IN_FOLDER: '移动失败，文件已存在于该文件夹中',
  FOLDER_NAME_SAME: '当前存在同名文件夹，请修改名称后再保存',
  EMAIL_CODE_REQUIRED: '为提高安全性，新增了认证代码功能。要使用此功能，请将应用程序更新到最新版本（v1.8.2或以上）。',
  FILE_SHARE_FAIL: '发送失败：{}',
  NOT_HAS_WEB_PERMISSION: '您的企业暂未购买该服务，无法访问',
  MODEL_OUTLINE_NOT_EXIST: '模型轮廓图不存在',
  WEB_MODEL_NO_AUTH: '权限不足',
  SEAT_NUM_TOO_SMALL: '席位数小于最小限制',
  SEAT_NUM_TOO_BIG: '席位数大于最大限制',
  SEAT_NUM_LESS_THAN_USED: '席位不足',
  CUSTOMER_PLAN_NOT_CANCELED: '客户没有已取消的套餐',
  CUSTOMER_PLAN_EXIST: '客户已经购买套餐',
  CUSTOMER_PLAN_ALREADY_CANCELED: '客户套餐已取消',
  CUSTOMER_PLAN_NOT_A: '客户不是套餐A',
  CUSTOMER_PLAN_PERIOD_ERROR: '不支持的付款周期',
  START_TIME_ILLEGAL: '开始时间错误',
  STRIPE_ONE_TIME_PRICE_NOT_FOUND: '套餐商品不存在',
  CUSTOMER_PLAN_EXPAND_NOT_FOUND_ITEM: '套餐商品不存在',
  ORDER_NOT_BELONG: '订单不属于当前会社',
  WEB_PERMISSION_NOT_ALLOW_INACTIVE: '权限不足',
  CUSTOMER_HAS_ACCOUNT_IN_USE: '会社存在账号在使用',
  CAD_PLAN_GOODS_NOT_EXIST: '没有找到CAD商品',
  CAD_ORDER_NOT_EXIST: 'CAD订单不存在',
  CAD_ORDER_STATUS_ERROR: 'CAD订单状态错误',
  CAD_ORDER_FILE_TOO_MANY: 'CAD订单文件大小超出上限',
  ACCOUNT_PLAN_PERIOD_NOT_ALLOW: '不支持的付款周期',
  CUSTOMER_PLAN_END_TIME_BEFORE_NOW: '套餐还未到期',
  EXPAND_SEAT_NOT_ZERO: '扩容席位不能为0',
  EXPAND_A_NOT_ALLOW: '套餐A不允许扩容',
  ACCOUNT_PLAN_GOODS_NOT_EXIST: '套餐商品不存在',
  CAD_PLAN_GOODS_IS_USED: 'CAD套餐在使用中',
  DOMAIN_ALREADY_EXIST: '域名已经存在',
  LOCATION_WITH_SNAPSHOT: '站点已经和漫游点关联了',
  LOCATION_NOT_FOUNT: '站点不存在',
  FLOOR_NOT_EXIST: '楼层不存在',
  AUTO_ALIGN_FAIL: '自动对齐失败',
  CAN_NOT_CHANGE_MEMBER_ROLE: '不能修改成员角色',
  CAN_NOT_USE_SEAT: '没有权限修改席位开关',
  APPLICATION_NOT_EXIST: '取消订阅申请不存在',
  PROCESSING_RESULT_NOT_EXIST: '取消订阅申请处理结果不存在',
  PLAN_CANCEL_APPLICATION_REASON_NOT_EXIST: '取消订阅申请理由不存在',
  PLAN_CANCEL_APPLICATION_OTHER_REASON_NULL: '取消订阅申请，其他理由不能为空',
  PLAN_CANCEL_APPLICATION_EMAIL_ERROR: '取消订阅申请，不是当前账号的邮箱',
  PLAN_CANCEL_APPLICATION_EXIST: '取消订阅申请已存在',
  ACCOUNT_CAN_NOT_USE: '您的账户不可用',
  ACCOUNT_NOT_BUY_PLAN: '您尚未购买Scanat服务，请至电脑端访问https://scanat.app/fee-plans.html 购买套餐后再次登录',
  CUSTOMER_NOT_BUY_PLAN: '您的会社尚未购买Scanat服务，暂无法登录',
  ACCOUNT_PLAN_EXPIRED: '您的套餐 {} 已于 {} 过期，请至电脑端访问https://scanat.app/fee-plans.html 购买套餐后再次登录',
  CUSTOMER_PLAN_EXPIRED: '您的会社购买的套餐 {} 已于 {} 过期，暂无法登录',
  ACCOUNT_PLAN_TOBE_EFFECTIVE: '您的服务将于 {} 生效，请在套餐生效后登录使用',
  ACCOUNT_NO_SEAT: '账号未开通席位，无法使用app',
  CAN_NOT_EDIT_MEMBER: '不能编辑成员',
  MODEL_IS_NOT_EXIST: '模型不存在',
  SHARE_LINK_NOT_EXIST: '分享链接不存在',
  NOT_CUSTOMER_MEMBER: '不是会社成员',
  SHARE_LINK_PASSWORD_ERROR: '分享链接密码错误',
  STRIPE_PAYMENT_METHOD_NOT_ALLOW: 'stripe支付方式不允许',
  NOT_ADMIN_FORBIDDEN: '不是管理员',
  NOT_ACTIVE_FORBIDDEN: '账号未激活',
  map: {
    gpsEnabledModelCount: '有GPS定位的模型数：{n}',
    emptyFolderNoGpsModel: '当前文件夹内没有任何有GPS定位的模型。',
    searchNoResult: '未找到结果。建议尝试更改关键字、检查输入错误或调整筛选器。'
  },
  maps: {
    hover: {
      showAllModels: '显示全部模型',
      zoomIn: '放大',
      zoomOut: '缩小'
    }
  },
  collaborator: {
    set: '设置协作者',
    add: '添加协作者',
    search: {
      email: '输入团队成员邮箱搜索'
    },
    online: '当前在线',
    owner: '公司所有者',
    title: '协作者'
  },
  fileModal: {
    cannotOperate: '该文件已被删除，无法操作'
  },
  collaboratorlist: {
    set: '协作者列表'
  },
  ACCOUNT_EMAIL_CAN_NOT_CREATE_CUSTOMER: '邮箱已注册账号，无法创建公司，请更换邮箱',
  COOPERATOR_PERMISSION_DENIED: '没有协作者权限',
  TEAM_SPACE_FOLDER_CREATE_NO_ADMIN: '非管理员不能创建团队空间文件夹',
  NOT_A_FOLDER: '不是一个文件夹',
  FOLDER_SPACE_MISMATCH: '找不到文件夹空间',
  FOLDER_DEPTH_EXCEEDED: '移动后超过10级层级，请重新选择',
  SPACE_FOLDER_CONTAIN_SUB_FOLDER: '不可移动至当前文件夹或子文件夹中',
  SPACE_FILE_ALREADY_IN_FOLDER: '已经存在于该文件夹中',
  CAN_NOT_FIND_SPACE_FILE: '该文件已被删除，无法访问',
  SPACE_FILE_PATH_NULL: '文件路径为空',
  COOPERATOR_ALREADY_EXISTS: '协作者已经在列表中，无法添加',
  INVITE_KEY_NOT_EXIST: '邀请链接不存在',
  INVITE_EMAIL_ERROR: '邀请邮箱不正确',
  INVITE_STATUS_ERROR: '邀请状态错误',
  INVITE_STATUS_EXPIRED: '邀请已过期',
  INVITE_CUSTOMER_PLAN_NOT_EXIST: '邀请方的会社没有购买订阅'
}
